import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: (_vm.templateGroupId ? _vm.$t("编辑") : _vm.$t("新增")) + _vm.$t("模版组"),
      visible: _vm.dialogVisible,
      width: 1200
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-steps", {
    attrs: {
      current: _vm.current
    }
  }, _vm._l(_vm.steps, function (item) {
    return _c("a-step", {
      key: item.title,
      attrs: {
        title: _vm.$t(item.title)
      }
    });
  }), 1), _vm.current == 0 ? _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("模板组名称")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择模版"),
      prop: "controlsGroupId"
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("a-select", {
    staticClass: "marginR15",
    staticStyle: {
      width: "300px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("页面类型")
    },
    on: {
      change: _vm.getDynamicResourcesFun
    },
    model: {
      value: _vm.pageType,
      callback: function ($$v) {
        _vm.pageType = $$v;
      },
      expression: "pageType"
    }
  }, _vm._l(_vm.pageTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1), _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请先选择页面类型再选择模板"),
      disabled: !_vm.pageType ? true : false
    },
    on: {
      change: _vm.templateChangeFun
    },
    model: {
      value: _vm.template,
      callback: function ($$v) {
        _vm.template = $$v;
      },
      expression: "template"
    }
  }, _vm._l(_vm.templateList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c("div", {
    staticClass: "des"
  }, [_vm._v(" * " + _vm._s(_vm.$t("模版可多选，但一页面类型只能选择一模版，如需更换已选数据，请删除已选数据后操作")) + " ")])]), _vm.tagList.length != 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("已选模版")
    }
  }, _vm._l(_vm.tagList, function (item) {
    return _c("a-tag", {
      key: item.id,
      attrs: {
        color: "blue",
        closable: ""
      },
      on: {
        close: function ($event) {
          return _vm.tagClose(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.type)) + ":" + _vm._s(item.name) + " ")]);
  }), 1) : _vm._e()], 1)], 1) : _vm.current == 1 ? _c("div", [_c("div", {
    staticClass: "des",
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("说明： 请按照实际操作流程完成页面按钮跳转步骤，首页需手动设置")) + " ")]), _c("div", {
    staticClass: "pageBox"
  }, _vm._l(_vm.templateConfig, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "nameBox"
    }, [_vm._v(_vm._s(_vm.$t(item.controlsGroupPageTypeName)) + ": " + _vm._s(_vm.$t(item.controlsGroupPageName)))]), _c("preview", {
      attrs: {
        itemObj: item,
        itemIndex: index,
        isMouse: true,
        templateCongfig: _vm.templateConfig
      },
      on: {
        setHome: _vm.setHomeFun
      }
    }), item.controlsGroupPageType == "QUERY_INFO_PAGE" || item.controlsGroupPageType == "INVOICE_LIST_PAGE" || item.controlsGroupPageType == "INVOICE_RECORD_LIST_PAGE" ? _c("div", {
      staticClass: "queryInfoBtnBox"
    }, _vm._l(item.controlsGroupConfig.controlsConfig, function (control, idx) {
      var _control$controlsObje, _control$controlsObje2, _control$controlsObje3, _control$controlsObje4;
      return _c("div", {
        key: idx,
        staticClass: "btnBox"
      }, [control.controlsMark == "queryInfo" ? [(_control$controlsObje = control.controlsObject.policySearch) !== null && _control$controlsObje !== void 0 && (_control$controlsObje = _control$controlsObje.invoiceInfo) !== null && _control$controlsObje !== void 0 && _control$controlsObje.buttonDisplay ? _vm._l(control.controlsObject.policySearch.invoiceInfo.buttons, function (item2) {
        var _vm$$t;
        return _c("div", {
          key: item2.buttonName,
          staticStyle: {
            display: "flex"
          }
        }, [_c("div", {
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", {
          staticClass: "button",
          style: {
            background: item2.buttonBgColor,
            color: item2.buttonFontColor,
            border: `1px solid ${item2.buttonFontColor}`
          }
        }, [((_vm$$t = _vm.$t(item2.buttonName)) === null || _vm$$t === void 0 ? void 0 : _vm$$t.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t("保单查询按钮")))]), _c("a-icon", {
          staticStyle: {
            position: "absolute",
            top: "-3px",
            right: "-15px",
            "font-size": "10px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
          staticStyle: {
            width: "115px"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: "",
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: _vm.cardControlsJumpFun
          },
          model: {
            value: item2.controlsJump,
            callback: function ($$v) {
              _vm.$set(item2, "controlsJump", $$v);
            },
            expression: "item2.controlsJump"
          }
        }, _vm._l(_vm.jumpList, function (item3, index3) {
          return _c("a-select-option", {
            key: index3,
            attrs: {
              value: item3.value
            }
          }, [_c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
        }), 1)], 1)]);
      }) : _vm._e(), (_control$controlsObje2 = control.controlsObject.policySearch) !== null && _control$controlsObje2 !== void 0 && (_control$controlsObje2 = _control$controlsObje2.buttonInfo) !== null && _control$controlsObje2 !== void 0 && _control$controlsObje2.buttonDisplay ? _vm._l(control.controlsObject.policySearch.buttonInfo.buttons, function (item2) {
        var _vm$$t2;
        return _c("div", {
          key: item2.buttonName,
          staticStyle: {
            display: "flex"
          }
        }, [_c("div", {
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", {
          staticClass: "button",
          style: {
            background: item2.buttonBgColor,
            color: item2.buttonFontColor,
            border: `1px solid ${item2.buttonFontColor}`
          }
        }, [((_vm$$t2 = _vm.$t(item2.buttonName)) === null || _vm$$t2 === void 0 ? void 0 : _vm$$t2.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t("保单卡片按钮")))]), _c("a-icon", {
          staticStyle: {
            position: "absolute",
            top: "-3px",
            right: "-15px",
            "font-size": "10px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
          staticStyle: {
            width: "115px"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: "",
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: _vm.cardControlsJumpFun
          },
          model: {
            value: item2.controlsJump,
            callback: function ($$v) {
              _vm.$set(item2, "controlsJump", $$v);
            },
            expression: "item2.controlsJump"
          }
        }, _vm._l(_vm.jumpList, function (item3, index3) {
          return _c("a-select-option", {
            key: index3,
            attrs: {
              value: item3.value
            }
          }, [_c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
        }), 1)], 1)]);
      }) : _vm._e(), (_control$controlsObje3 = control.controlsObject.orderSearch) !== null && _control$controlsObje3 !== void 0 && (_control$controlsObje3 = _control$controlsObje3.buttonInfo) !== null && _control$controlsObje3 !== void 0 && _control$controlsObje3.buttonDisplay ? _vm._l(control.controlsObject.orderSearch.buttonInfo.buttons, function (item2, index2) {
        var _vm$$t3;
        return _c("div", {
          key: index2,
          staticStyle: {
            display: "flex"
          }
        }, [_c("div", {
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", {
          staticClass: "button",
          style: {
            background: item2.buttonBgColor,
            color: item2.buttonFontColor,
            border: `1px solid ${item2.buttonFontColor}`
          }
        }, [((_vm$$t3 = _vm.$t(item2.buttonName)) === null || _vm$$t3 === void 0 ? void 0 : _vm$$t3.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t("订单卡片按钮")))]), _c("a-icon", {
          staticStyle: {
            position: "absolute",
            top: "-3px",
            right: "-15px",
            "font-size": "10px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
          staticStyle: {
            width: "115px"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: "",
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: _vm.cardControlsJumpFun
          },
          model: {
            value: item2.controlsJump,
            callback: function ($$v) {
              _vm.$set(item2, "controlsJump", $$v);
            },
            expression: "item2.controlsJump"
          }
        }, _vm._l(_vm.jumpList, function (item3, index3) {
          return _c("a-select-option", {
            key: index3,
            attrs: {
              value: item3.value
            }
          }, [_c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
        }), 1)], 1)]);
      }) : _vm._e()] : _vm._e(), control.controlsMark == "invoiceList" ? _vm._l((_control$controlsObje4 = control.controlsObject.buttonInfo) === null || _control$controlsObje4 === void 0 ? void 0 : _control$controlsObje4.buttons, function (item2, index2) {
        var _vm$$t4;
        return _c("div", {
          key: index2,
          staticStyle: {
            display: "flex"
          }
        }, [_c("div", {
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", {
          staticClass: "button",
          style: {
            background: item2.buttonBgColor,
            color: item2.buttonFontColor,
            border: `1px solid ${item2.buttonFontColor}`
          }
        }, [((_vm$$t4 = _vm.$t(item2.buttonName)) === null || _vm$$t4 === void 0 ? void 0 : _vm$$t4.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t("开票记录按钮")))]), _c("a-icon", {
          staticStyle: {
            position: "absolute",
            top: "-3px",
            right: "-15px",
            "font-size": "10px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
          staticStyle: {
            width: "115px"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: "",
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: _vm.cardControlsJumpFun
          },
          model: {
            value: item2.controlsJump,
            callback: function ($$v) {
              _vm.$set(item2, "controlsJump", $$v);
            },
            expression: "item2.controlsJump"
          }
        }, _vm._l(_vm.jumpList, function (item3, index3) {
          return _c("a-select-option", {
            key: index3,
            attrs: {
              value: item3.value
            }
          }, [_c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
        }), 1)], 1)]);
      }) : _vm._e(), control.controlsMark == "invoiceRecordList" ? _vm._l(control.controlsObject.buttonInfo.buttons, function (item2, index2) {
        var _vm$$t5;
        return _c("div", {
          key: index2,
          staticStyle: {
            display: "flex"
          }
        }, [_c("div", {
          staticStyle: {
            position: "relative"
          }
        }, [_c("div", {
          staticClass: "button",
          style: {
            background: item2.buttonBgColor,
            color: item2.buttonFontColor,
            border: `1px solid ${item2.buttonFontColor}`
          }
        }, [((_vm$$t5 = _vm.$t(item2.buttonName)) === null || _vm$$t5 === void 0 ? void 0 : _vm$$t5.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t("开票记录卡片按钮")))]), _c("a-icon", {
          staticStyle: {
            position: "absolute",
            top: "-3px",
            right: "-15px",
            "font-size": "10px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
          staticStyle: {
            width: "115px"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            allowClear: "",
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: _vm.cardControlsJumpFun
          },
          model: {
            value: item2.controlsJump,
            callback: function ($$v) {
              _vm.$set(item2, "controlsJump", $$v);
            },
            expression: "item2.controlsJump"
          }
        }, _vm._l(_vm.jumpList, function (item3, index3) {
          return _c("a-select-option", {
            key: index3,
            attrs: {
              value: item3.value
            }
          }, [_c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
        }), 1)], 1)]);
      }) : _vm._e()], 2);
    }), 0) : _vm._e(), _c("div", {
      staticClass: "btnBox"
    }, [item.controlsGroupConfig.controlsConfig[item.controlsGroupConfig.controlsConfig.length - 1].controlsMark === "bottomButton" ? _vm._l(item.controlsGroupConfig.controlsConfig[item.controlsGroupConfig.controlsConfig.length - 1].controlsObject.buttonInfo, function (item2, index2) {
      var _item2$buttonPopUpCon, _item2$buttonPopUpCon2, _item2$buttonPopUpCon3, _item2$buttonPopUpCon4, _item2$buttonPopUpCon5, _item2$buttonPopUpCon6, _item2$buttonPopUpCon7, _vm$$t6;
      return _c("div", {
        key: index2
      }, [item2.buttonPopUp ? [_c("div", {
        staticStyle: {
          position: "relative"
        }
      }, [_c("div", {
        staticClass: "button",
        style: "background:" + ((_item2$buttonPopUpCon = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon === void 0 ? void 0 : _item2$buttonPopUpCon.buttonBgColor) + ";color:" + ((_item2$buttonPopUpCon2 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon2 === void 0 ? void 0 : _item2$buttonPopUpCon2.buttonFontColor) + ";border:1px solid " + ((_item2$buttonPopUpCon3 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon3 === void 0 ? void 0 : _item2$buttonPopUpCon3.buttonFontColor)
      }, [((_item2$buttonPopUpCon4 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon4 === void 0 ? void 0 : _item2$buttonPopUpCon4.buttonName.length) < 13 ? _c("span", [_vm._v(_vm._s((_item2$buttonPopUpCon5 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon5 === void 0 ? void 0 : _item2$buttonPopUpCon5.buttonName))]) : _c("a-tooltip", {
        attrs: {
          placement: "top"
        }
      }, [_c("template", {
        slot: "title"
      }, [_vm._v(_vm._s((_item2$buttonPopUpCon6 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon6 === void 0 ? void 0 : _item2$buttonPopUpCon6.buttonName))]), _c("span", [_vm._v(_vm._s((_item2$buttonPopUpCon7 = item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump")) === null || _item2$buttonPopUpCon7 === void 0 ? void 0 : _item2$buttonPopUpCon7.buttonName))])], 2)], 1), _c("a-tooltip", [_c("template", {
        slot: "title"
      }, [_vm._v(_vm._s(_vm.$t("页面弹窗按钮")))]), _c("a-icon", {
        staticStyle: {
          position: "absolute",
          top: "-3px",
          right: "-15px",
          "font-size": "10px"
        },
        attrs: {
          type: "question-circle"
        }
      })], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
        staticStyle: {
          width: "115px"
        },
        attrs: {
          placeholder: _vm.$t("请选择"),
          allowClear: "",
          getPopupContainer: triggerNode => triggerNode.parentNode,
          dropdownClassName: "mul-select-dropdown"
        },
        on: {
          change: _vm.controlsJumpFun
        },
        model: {
          value: item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump").controlsJump,
          callback: function ($$v) {
            _vm.$set(item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == "jump"), "controlsJump", $$v);
          },
          expression: "item2.buttonPopUpConfig.buttonInfo.find(i => i.buttonEvent == 'jump').controlsJump"
        }
      }, _vm._l(_vm.jumpList, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3.value,
            disabled: item3.disabled || item.controlsGroupPageType == item3.value ? true : false
          }
        }, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
      }), 1)], 1)] : [_c("div", {
        staticClass: "button",
        style: "background:" + item2.buttonBgColor + ";color:" + item2.buttonFontColor + ";border:1px solid " + item2.buttonFontColor
      }, [((_vm$$t6 = _vm.$t(item2.buttonName)) === null || _vm$$t6 === void 0 ? void 0 : _vm$$t6.length) < 13 ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]) : _c("a-tooltip", {
        attrs: {
          placement: "top"
        }
      }, [_c("template", {
        slot: "title"
      }, [_vm._v(_vm._s(_vm.$t(item2.buttonName)))]), _c("span", [_vm._v(_vm._s(_vm.$t(item2.buttonName)))])], 2)], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("跳转至")) + " "), _c("a-select", {
        staticStyle: {
          width: "115px"
        },
        attrs: {
          placeholder: _vm.$t("请选择"),
          allowClear: "",
          getPopupContainer: triggerNode => triggerNode.parentNode,
          dropdownClassName: "mul-select-dropdown"
        },
        on: {
          change: _vm.controlsJumpFun
        },
        model: {
          value: item2.controlsJump,
          callback: function ($$v) {
            _vm.$set(item2, "controlsJump", $$v);
          },
          expression: "item2.controlsJump"
        }
      }, _vm._l(_vm.jumpList, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3.value,
            disabled: item3.disabled || item.controlsGroupPageType == item3.value ? true : false
          }
        }, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)))]), _c("div", [_vm._v(" " + _vm._s(_vm.$t(item3.name)) + " "), item3.pageName ? _c("span", [_vm._v("：")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t(item3.pageName)) + " ")])], 2)], 1);
      }), 1)], 1)]], 2);
    }) : _vm._e()], 2)], 1);
  }), 0)]) : _vm._e(), _c("template", {
    slot: "footer"
  }, [_vm.current == 0 ? _c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("完成选择，下一步")) + " ")]) : _vm._e(), _vm.current == 1 ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      size: "small"
    },
    on: {
      click: function ($event) {
        _vm.current = 0;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上一步")) + " ")]) : _vm._e(), _vm.current == 1 ? _c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };